export default "__VITE_ASSET__Cl8CRMAq__"